module.exports = __webpack_public_path__ + "media/images/fantasy_logo-a2706ab342eff4e864861f91d8ff18b9.png";